import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const companyInfo = [
  { label: '会社名', value: '株式会社Ocean' },
  { label: '設立', value: '2023年07月06日' },
  { label: '代表者', value: '小西 真平' },
  { label: '所在地', value: '〒530-0043 大阪府大阪市北区天満１丁目４−１９ キオプラザ天満橋' },
  { label: 'メールアドレス', value: 'banking@oceansubstitute.com' },
  { label: '電話番号', value: '080-4480-0273' },
  { label: '事業内容', value: '各種システム・ソフトウェアの企画・開発・設計・配信、アプリケーションソフトの開発・制作・配信、Webサービスの運営、インターネットによる広告業及び広告代理店' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-teal-900 to-cyan-800 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src="https://readdy.ai/api/search-image?query=abstract%20turquoise%20ocean%20wave%20pattern%20digital%20technology%20background%20minimal%20clean%20teal%20cyan%20gradient%20with%20geometric%20shapes&width=1920&height=400&seq=ocean-about-hero-01&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-teal-200 text-xs font-semibold uppercase tracking-widest mb-3">About Us</p>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>会社概要</h1>
          <p className="text-white/70 text-sm">株式会社Oceanについてご紹介します。</p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="rounded-2xl border border-gray-100 overflow-hidden">
            {companyInfo.map((item, idx) => (
              <div key={item.label} className={`flex flex-col sm:flex-row ${idx % 2 === 0 ? 'bg-gray-50/50' : 'bg-white'}`}>
                <div className="sm:w-40 px-5 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wide shrink-0">{item.label}</div>
                <div className="px-5 py-4 text-sm text-gray-800 leading-relaxed">{item.value}</div>
              </div>
            ))}
          </div>

          <div className="mt-10 rounded-2xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.492259813044!2d135.5183808!3d34.69276200000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e6d63231da25%3A0xe2a1144362219c1a!2z44CSNTMwLTAwNDMg5aSn6Ziq5bqc5aSn6Ziq5biC5YyX5Yy65aSp5rqA77yR5LiB55uu77yU4oiS77yR77yZIOOCreOCquODl-ODqeOCtuWkqea6gOapiw!5e0!3m2!1sja!2sjp!4v1776757432733!5m2!1sja!2sjp"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="株式会社Ocean 所在地"
              className="rounded-2xl"
            ></iframe>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
